import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const ArrowIcon = React.memo(
  ({ fill = variables['colors-mc-text-primary'], strokeWidth = '1', width = '16', viewBox = '0 0 16 16' }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(width)}
      viewBox={viewBox}
    >
      <path
        id='chevron-left'
        d='M12.408,1.669a.577.577,0,0,1,0,.817L5.893,9l6.515,6.514a.578.578,0,1,1-.817.817L4.669,9.408a.577.577,0,0,1,0-.817l6.922-6.922a.577.577,0,0,1,.817,0Z'
        transform='translate(-3.999 -0.999)'
        fill={fill}
        stroke={fill}
        strokeWidth={strokeWidth}
        fillRule='evenodd'
      />
    </svg>
  )
);
ArrowIcon.displayName = 'ArrowIcon';

export default ArrowIcon;
